<template>
  <div class="mall-box">
    <img src="@/assets/img/images/no-data-yh.png" alt="nodata.png" />
    <p>{{ $t("tipsVal.noBankCardTips") }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.mall-box {
  margin: 60px auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 240px;
    height: 240px;
  }
  p {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #999999;
  }
}
</style>
